import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './components/about/about.component';
import { EventsComponent } from './components/events/events.component';
import { JobDetailComponent } from './components/job-detail/job-detail.component';
import { JobsComponent } from './components/jobs/jobs.component';
import { LandingComponent } from './components/landing/landing.component';
import { ManageJobComponent } from './components/manage-job/manage-job.component';
import { SponsorsComponent } from './components/sponsors/sponsors.component';
import { PodcastComponent } from './components/podcast/podcast.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'events',
    component: EventsComponent,
  },
  {
    path: 'podcast',
    component: PodcastComponent,
  },
  {
    path: 'events/:series',
    component: EventsComponent,
  },
  {
    path: 'jobs',
    component: JobsComponent,
  },
  {
    path: 'jobs/:jobId',
    component: JobDetailComponent,
  },
  {
    path: 'manageJob',
    component: ManageJobComponent,
  },
  {
    path: 'sponsors',
    component: SponsorsComponent,
  },
  {
    path: 'home',
    component: LandingComponent,
  },
  {
    path: 'code-of-conduct',
    loadChildren: () =>
      import('./components/code-of-conduct/code-of-conduct.component').then(
        (m) => m.CodeOfConductComponentModule
      ),
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
